import { render } from "./Income.vue?vue&type=template&id=7bf5183c"
import script from "./Income.vue?vue&type=script&lang=js"
export * from "./Income.vue?vue&type=script&lang=js"
script.render = render

export default script